import React from 'react';
import './Badge.css';

export default function Badge({ children, variant = 'default', dot = false }) {
  return (
    <span className={`ui-badge ui-badge-${variant}`}>
      {dot && <span className="ui-badge-dot" />}
      {children}
    </span>
  );
}

export function NotificationBadge({ count, children }) {
  if (!count) return children;
  return (
    <span className="ui-notification-wrap">
      {children}
      <span className="ui-notification-count">{count > 99 ? '99+' : count}</span>
    </span>
  );
}
